import React from 'react'
import './highlights.css'
import {BiCheck} from 'react-icons/bi'

const Highlights = () => {
  return (
    <section id='highlights'>
      <h5>Proven Impact</h5>
      <h2>Enterprise Experience Highlights</h2>

      <div className='container highlights__container'>
        <article className='highlight__card'>
          <div className='highlight__card-header'>
            <BiCheck className='highlight__card-icon'/>
            <h3>Production Support & Incident Management</h3>
          </div>
          <div className='highlight__card-content'>
            <p><strong>~20 Production Incidents Monthly:</strong> Managed complex technical escalations through log analysis, API debugging, and cross-functional coordination</p>
            <p><strong>Root Cause Analysis:</strong> Systematic troubleshooting of enterprise-scale systems to resolve customer-impacting issues quickly</p>
          </div>
        </article>

        <article className='highlight__card'>
          <div className='highlight__card-header'>
            <BiCheck className='highlight__card-icon'/>
            <h3>Performance Optimization & Customer Impact</h3>
          </div>
          <div className='highlight__card-content'>
            <p><strong>27% Performance Improvement:</strong> Call center application load time reduced from 15.51s to 11.97s through SQL optimization and database indexing</p>
            <p><strong>Direct Customer Value:</strong> Improved agent productivity and customer experience for enterprise operations teams</p>
          </div>
        </article>

        <article className='highlight__card'>
          <div className='highlight__card-header'>
            <BiCheck className='highlight__card-icon'/>
            <h3>MigrAIte: AI-Powered Database Migration Platform</h3>
          </div>
          <div className='highlight__card-content'>
            <p><strong>Core Implementation:</strong> Built schema onboarding module enabling AI-driven database schema classification and metadata enrichment. Implemented role-based access control (RBAC) for secure multi-team access. Developed chat assist UI for interactive schema analysis and data lineage exploration.</p>
            <p><strong>Impact:</strong> Platform used by 5+ internal teams for database migration planning and execution. Streamlined complex schema analysis through AI-powered classification and visualization tools.</p>
          </div>
        </article>

        <article className='highlight__card'>
          <div className='highlight__card-header'>
            <BiCheck className='highlight__card-icon'/>
            <h3>Container Orchestration & Platform Modernization</h3>
          </div>
          <div className='highlight__card-content'>
            <p><strong>Kubernetes Deployment Coordination:</strong> Supported large-scale containerization and Kubernetes deployment initiatives for enterprise applications. Coordinated migration activities across multiple teams and platforms.</p>
            <p><strong>Platform Upgrade & Operational Readiness:</strong> Managed compliance reviews, security certifications, and operational readiness for modernized platforms. Risk mitigation and cross-team coordination.</p>
          </div>
        </article>

        <article className='highlight__card'>
          <div className='highlight__card-header'>
            <BiCheck className='highlight__card-icon'/>
            <h3>Cross-Functional Technical Leadership</h3>
          </div>
          <div className='highlight__card-content'>
            <p><strong>Team Coordination:</strong> Worked with engineering teams, product managers, business teams, offshore vendors, and support teams to resolve issues and drive initiatives</p>
            <p><strong>Customer-Centric Problem Solving:</strong> Translated business requirements into technical solutions; led requirements assessment and impact analysis</p>
          </div>
        </article>

        <article className='highlight__card'>
          <div className='highlight__card-header'>
            <BiCheck className='highlight__card-icon'/>
            <h3>Strategic Leadership & Recognition</h3>
          </div>
          <div className='highlight__card-content'>
            <p><strong>3x Spotlight Award Recipient:</strong> Recognized for Customer Success, Accountability & Teamwork, Project Launch & Operational Support</p>
            <p><strong>MBA in Strategic Management:</strong> Combines technical depth with business strategy and leadership thinking</p>
            <p><strong>Agile Leadership:</strong> PSM I & PSM II Scrum certifications demonstrating commitment to customer-focused delivery</p>
          </div>
        </article>
      </div>
    </section>
  )
}

export default Highlights
